export enum PaisResidencia {
  Brasil = 'brasil',
  Outro = 'outro'
}

export enum PaisResidenciaFormatado {
  brasil = 'Brasil',
  outro = 'Outro'
}
